module.exports = __webpack_public_path__ + "media/images/expert__footaises-6f036fd7b29e3c884e58b3076427878d.png";